module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showgrid),
      expression: "showgrid"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.formEditavel) ? _c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "tooltip": "Adiciona um público alvo",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showgrid = !_vm.showgrid
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Nova equipe")]) : _vm._e()])]), _vm._v(" "), (_vm.formEditavel) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {}, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "bt_remunerado",
      fn: function(row) {
        return [_vm._v(_vm._s(('' + row.value) === '1' ? 'Sim' : 'Não'))]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [(_vm.formEditavel) ? _c('div', [_c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.edita(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
          directives: [{
            name: "confirm",
            rawName: "v-confirm",
            value: ({
              ok: function (retorno) { return _vm.exclui(row); },
              cancel: _vm.doNothing,
              message: 'Deseja <b>APAGAR</b> o item ' + row.item.ds_cargo + ' ?'
            }),
            expression: "{ok: retorno => exclui(row), cancel: doNothing,\n                         message: 'Deseja <b>APAGAR</b> o item ' + row.item.ds_cargo + ' ?'}"
          }],
          staticClass: "btn btn-danger btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), (_vm.table.items.length > _vm.table.perPage) ? _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12",
      "right": ""
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)])])]), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cargo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "role"
    }
  }, [_vm._v("Cargo no projeto:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipe.ds_cargo),
      expression: "equipe.ds_cargo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cargo",
      "type": "text",
      "maxlength": "255",
      "data-vv-as": "Cargo no Projeto"
    },
    domProps: {
      "value": (_vm.equipe.ds_cargo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.equipe, "ds_cargo", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('cargo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cargo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('quantidade')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "quantidade"
    }
  }, [_vm._v("Quantidade:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipe.nr_quantidade),
      expression: "equipe.nr_quantidade"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "quantidade",
      "type": "number",
      "min": "1",
      "max": "2147483647",
      "data-vv-as": "Quantidade"
    },
    domProps: {
      "value": (_vm.equipe.nr_quantidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.equipe, "nr_quantidade", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('quantidade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('perfil profissional pretendido')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "perfilProf"
    }
  }, [_vm._v("Perfil profissional pretendido:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipe.ds_perfil_desejado),
      expression: "equipe.ds_perfil_desejado"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Informar a escolaridade",
      "data-vv-as": "Perfil profissional pretendido",
      "name": "perfil profissional pretendido",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.equipe.ds_perfil_desejado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.equipe, "ds_perfil_desejado", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('perfil profissional pretendido')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('perfil profissional pretendido')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('forma de contratação')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "formaContratacao"
    }
  }, [_vm._v("Forma de contratação:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipe.ds_forma_contratacao),
      expression: "equipe.ds_forma_contratacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "forma de contratação",
      "data-vv-as": "Forma de contratação"
    },
    on: {
      "select": _vm.buscaFormaContratacao,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.equipe, "ds_forma_contratacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.formasContratacao), function(forma) {
    return _c('option', {
      domProps: {
        "value": forma
      }
    }, [_vm._v(_vm._s(forma))])
  }), 0)]), _vm._v(" "), (_vm.errors.first('forma de contratação')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('forma de contratação')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('carga horaria')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "cargaHoraria"
    }
  }, [_vm._v("Carga horária semanal:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipe.dc_carga_horaria),
      expression: "equipe.dc_carga_horaria"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "carga horaria",
      "type": "number",
      "min": "1",
      "max": "2147483647",
      "data-vv-as": "Carga horária semanal"
    },
    domProps: {
      "value": (_vm.equipe.dc_carga_horaria)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.equipe, "dc_carga_horaria", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Horas")])]), _vm._v(" "), (_vm.errors.first('carga horaria')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('carga horaria')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('remunerado pelo projeto')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "remunerado"
    }
  }, [_vm._v("É remunerado pelo projeto?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipe.bt_remunerado),
      expression: "equipe.bt_remunerado"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "remunerado pelo projeto",
      "data-vv-as": "É remunerado pelo projeto?"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.equipe, "bt_remunerado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Sim")])])]), _vm._v(" "), (_vm.errors.first('remunerado pelo projeto')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('remunerado pelo projeto')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Resumo das atividades')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "resumoAtividade"
    }
  }, [_vm._v("Resumo das atividades:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('textarea', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.equipe.ds_resumo_atividades),
      expression: "equipe.ds_resumo_atividades"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Resumo das atividades",
      "placeholder": "Descreva as principais atividades que serão executadas no projeto por esse(s) proficional(is)",
      "rows": "3",
      "data-vv-as": "Resumo das atividades"
    },
    domProps: {
      "value": (_vm.equipe.ds_resumo_atividades)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.equipe, "ds_resumo_atividades", $event.target.value)
      }
    }
  }, [_vm._v("              " + _vm._s(_vm.equipe.ds_resumo_atividades) + "\n            ")])]), _vm._v(" "), (_vm.errors.first('Resumo das atividades')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Resumo das atividades')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-31135166!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/equipeProjeto.vue
// module id = 1818
// module chunks = 2